import React from 'react';
import * as S from './CancellationBody.styles';

import BreakUpInfo from './BreakUpInfo/BreakUpInfo';
import RefundSelect from './RefundSelect/RefundSelect';

const CancellationBody = ({header, activeTab, updateActiveTab, breakupList, freeCancellationText, selectedRefundMode, updateRefundMode, refundBreakUp, confirmCancellation, showPayModeButton}) => {
  switch (activeTab) {
    case 'refund':
      return <BreakUpInfo
        header={header}
        updateActiveTab={updateActiveTab}
        breakupList={breakupList}
        freeCancellationText={freeCancellationText}
        showPayModeButton={showPayModeButton}
      />;
    case 'confirm':
      return <RefundSelect
        header={header}
        updateActiveTab={updateActiveTab}
        selectedRefundMode={selectedRefundMode}
        updateRefundMode={updateRefundMode}
        refundBreakUp={refundBreakUp}
        confirmCancellation={confirmCancellation}
      />;
    default:
      return null;
  }
}

export default CancellationBody;